const usersSearchResultsActions = {
  SET_USERS_INIT_STATE: 'SET_USERS_INIT_STATE',
  GET_USERS: 'GET_USERS'
};
export default usersSearchResultsActions;
